import Details from 'components/Container/Details/Details'
import WithHistory from 'components/Container/WithHistory/WithHistory'
import { TContainerProps } from 'components/Container/types'

export const Container = (props: TContainerProps) => <Details {...props} />

Container.Details = Details
Container.WithHistory = WithHistory
